import {CommonModule} from '@angular/common';
import {Component} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-evaluation-legend',
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './evaluation-legend.component.html',
})
export class EvaluationLegendComponent {
  expanded = false;
}
